import React from 'react';

import { Text } from '@mantine/core';

import CaloriesInput from './CaloriesInput';
import DistanceInput from './DistanceInput';
import RepsInput from './RepsInput';
import RoundsInput from './RoundsInput';
import RoundsRepsInput from './RoundsRepsInput';
import TimeInput from './TimeInput';
import { DistanceUnit, MovementResult, ScoringType, WeightUnit } from './types';
import WeightSetsInput from './WeightSetsInput';

interface ScoringTypeInputProps {
  scoringType: ScoringType | undefined;
  value: MovementResult | undefined;
  onChange: (value: MovementResult) => void;
  weightUnit: WeightUnit;
  distanceUnit: DistanceUnit;
  targetReps: ReadonlyArray<number>;
  enlarged?: boolean;
}

const ScoringTypeInput = ({
  scoringType,
  value,
  onChange,
  weightUnit,
  distanceUnit,
  targetReps,
  enlarged = false,
}: ScoringTypeInputProps): JSX.Element | null => {
  if (!scoringType || !value) {
    return (
      <Text size='sm' color='dimmed' fs='italic'>
        Scoring type not configured for this movement.
      </Text>
    );
  }

  switch (value.scoringType) {
    case ScoringType.TIME:
      return <TimeInput value={value} onChange={onChange} enlarged={enlarged} />;
    case ScoringType.CALORIES:
      return <CaloriesInput value={value} onChange={onChange} enlarged={enlarged} />;
    case ScoringType.DISTANCE:
      return <DistanceInput value={value} onChange={onChange} unit={distanceUnit} enlarged={enlarged} />;
    case ScoringType.REPS:
      return <RepsInput value={value} onChange={onChange} enlarged={enlarged} />;
    case ScoringType.ROUNDS:
      return <RoundsInput value={value} onChange={onChange} enlarged={enlarged} />;
    case ScoringType.ROUNDS_REPS:
      return <RoundsRepsInput value={value} onChange={onChange} enlarged={enlarged} />;
    case ScoringType.WEIGHT:
      return (
        <WeightSetsInput
          value={value}
          onChange={onChange}
          unit={weightUnit}
          targetReps={targetReps}
          enlarged={enlarged}
        />
      );
  }
};

export default ScoringTypeInput;
